export const DEFAULT_EXCLUDE_API_PATTERNS: readonly string[] = Object.freeze([
  "/batchPredictionJobs/"
]);
